import React, { useId } from 'react';
import { Antenna, Cable, Cpu, Globe, HardDrive, MemoryStick, Monitor, Network, Radio, Router, ShieldCheck, Smartphone, Usb, Wifi, Zap, type LucideIcon } from 'lucide-react';

// Public feature keys are opaque to commerce; this registry is frontend-owned.
export const FEATURE_ICON_MAP: Readonly<Record<string, LucideIcon>> = Object.freeze({
  wifi: Wifi,
  ethernet: Cable,
  network: Network,
  cpu: Cpu,
  usb: Usb,
  power: Zap,
  poe: Zap,
  shield: ShieldCheck,
  router: Router,
  antenna: Antenna,
  storage: HardDrive,
  memory: MemoryStick,
  radio: Radio,
  smartphone: Smartphone,
  monitor: Monitor,
  globe: Globe,
});
export const FEATURE_ICON_KEYS = Object.keys(FEATURE_ICON_MAP);

export function FeatureIcon({ name, className = 'h-4 w-4 shrink-0' }: { name?: string | null; className?: string }) {
  const Icon = name && Object.prototype.hasOwnProperty.call(FEATURE_ICON_MAP, name) ? FEATURE_ICON_MAP[name] : undefined;
  return Icon ? <Icon className={className} aria-hidden="true" data-feature-icon={name} /> : null;
}

export function FeatureIconPicker({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  const listId = useId();
  const known = Object.prototype.hasOwnProperty.call(FEATURE_ICON_MAP, value);
  return (
    <div className="space-y-2">
      <input aria-label="Icon" list={listId} value={value} onChange={event => onChange(event.target.value)} placeholder="e.g. wifi, ethernet, cpu" className="w-full rounded-control border border-border bg-background px-3 py-2 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring" />
      <datalist id={listId}>{FEATURE_ICON_KEYS.map(key => <option key={key} value={key} />)}</datalist>
      {known ? <span role="img" aria-label={`Icon preview: ${value}`} className="inline-flex items-center gap-2 text-sm text-muted-foreground"><FeatureIcon name={value} />{value}</span> : <p className="text-xs text-muted-foreground">{value ? 'No preview for this key. It can still be saved.' : 'No icon selected.'}</p>}
    </div>
  );
}
